var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMaximize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1 18a4 4 0 0 0 4 4h11a4 4 0 0 0 4-4v-4a1 1 0 1 0-2 0v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h3a1 1 0 1 0 0-2H5a4 4 0 0 0-4 4z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 4h-6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-6-2a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm-3.793 10.293a1 1 0 0 1 0 1.414L8.414 15.5H9a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v.586l1.793-1.793a1 1 0 0 1 1.414 0",
  clipRule: "evenodd"
})));
export default SvgIcMaximize;